import { render, staticRenderFns } from "./Lgx241890469603180544.vue?vue&type=template&id=24fc8d78&"
import script from "./Lgx241890469603180544.vue?vue&type=script&lang=js&"
export * from "./Lgx241890469603180544.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports